import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpHandler, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { StopOptimizationHttpParams } from './stop-optimization-http-params';
import { OptimizationService } from '../services';

@Injectable()
export class OptimizationInterceptor implements HttpInterceptor {
    private readonly optimizationService = inject(OptimizationService);


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            switchMap(event => {
                if (
                    event instanceof HttpResponse &&
                    request.params instanceof StopOptimizationHttpParams &&
                    request.params.stopOptimization
                ) {
                    this.optimizationService.stopOptimizationProcess().subscribe();
                }
                return of(event);
            })
        );
    }
}
